const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const legacyGinSubtaskActionRoute = {
	name: 'legacy-gin-subtask-action',
	path: `/secure/(Move|Convert)SubTask(\\w*)${defaultSuffix}.jspa`,
};
